import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Testimonials from '../components/Testimonials';
import Contact from '../components/Contact';

const TestimonialsPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow pt-20">
        <Testimonials />
        <div className="bg-gray-50 py-20 text-center">
            <h3 className="text-3xl font-black text-brand-black mb-8">Join the Elite</h3>
            <Contact />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TestimonialsPage;